<template>
  <transition name="forup">
    <div class="bg-white addmemo" v-if="this.boxshow" >
      <div class="memo">
        <div class="memo-title">
          请添加订单备注
        </div>
        <textarea placeholder="请输入订单备注，最多100个字" v-model="billHead.billMemo" maxlength="30"
                  onchange="this.value=this.value.substring(0, 100)" onkeydown="this.value=this.value.substring(0, 100)"
                  onkeyup="this.value=this.value.substring(0, 100)" class="memo-text bg-yellow"></textarea>
        <div class="memo-button-flex">
          <div class="memo-button bg-yellow color-gray" @click.stop="bnCancelClick()">取消</div>
          <div class="memo-button bg-gray-yellow color-white" @click.stop="bnOkClick()">确定</div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import bgyun from '../bg-yun/bgyun.vue';
  import ServiceUtil from '../../service/ServiceUtils'

  export default {
    name: 'OrderMemo',
    data () {
      return {
        billHead:{},
        boxshow:false,
        _callback:''
      }
    },
    components:{
      'bg-yun':bgyun
    },
    methods:{
//      点击取消
      bnCancelClick(){
        this.boxshow = false;
      },
      bnOkClick(){
          this.boxshow = false;
          ServiceUtil.setBillHeadCache();
          if(this._callback){
            this._callback();
          }
      },
      togglebox(callbck){
        this.boxshow = true;
        this._callback = callbck;
      }
    },
    mounted(){
        this.billHead = ServiceUtil.orderedTotal;
    }
  }
</script>
<style scoped lang="scss">

  .bg-white{background:#ffffff}

  .memo{
    width: 90%;
    margin: 0 5%;
    textarea{
      font-size: 1rem;
    }
  }
  .bg-yellow{background: #F7F3E7;}
  .memo-title{
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #dddddd;
    text-align: center;
    line-height: 50px;
    color: #000000;
  }
  .color-white{color:#ffffff}
  .bg-gray-yellow{background:#CEB66B}
  .memo-name{
    width: 100%;
    height: 50px;
    text-align: left;
    line-height: 50px;
    color: #000000;
  }
  .memo-text{
    width: -webkit-calc(100% - 20px);
    width: -moz-calc(100% - 20px);
    width: calc(100% - 20px);
    height: 100px;
    padding: 10px;
    border: none;
    font-size: 20px;
  }

  .memo-button-flex{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .memo-button{
    width: 160px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border-radius: 5px;
    margin-top: 20px;
    font-size: 1.1em;
  }
  .addmemo{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 16;
  }


</style>



// WEBPACK FOOTER //
// src/components/orderMemo/orderMemo.vue